export default "__VITE_ASSET__Ch7wuZZ2__"